<div class="surface-card p-6">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h2 class="text-text-primary text-xl font-semibold mb-1">{{ 'seekerDashboard.alerts.title' | translate }}</h2>
      <p class="text-text-secondary text-sm">{{ 'seekerDashboard.alerts.subtitle' | translate }}</p>
    </div>
    <button class="btn btn-primary px-4 py-2 text-sm font-medium shadow-glow">
      {{ 'seekerDashboard.alerts.addNewAlert' | translate }}
    </button>
  </div>

  <!-- Alerts List -->
  <div class="space-y-4">
    <!-- Alert Item -->
    <div class="surface-card p-5 hover:border-primary/50 transition-colors">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-surface-elevated border border-border rounded-lg flex items-center justify-center">
            <i class="fa-solid fa-bell text-warning"></i>
          </div>
          <div>
            <h3 class="text-text-primary font-medium">{{ 'seekerDashboard.alerts.alert1Location' | translate }}</h3>
            <p class="text-sm text-text-secondary">{{ 'seekerDashboard.alerts.alert1Details' | translate }}</p>
          </div>
        </div>
        <label class="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" class="sr-only peer" checked>
          <div
            class="w-11 h-6 bg-surface-elevated border border-border peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary peer-checked:border-primary shadow-inner">
          </div>
        </label>
      </div>
      <div class="bg-surface-elevated border border-primary/30 rounded-lg p-3 text-sm text-primary">
        {{ 'seekerDashboard.alerts.alert1Match' | translate }}
      </div>
    </div>

    <!-- Alert Item 2 -->
    <div class="surface-card p-5 hover:border-primary/50 transition-colors">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-surface-elevated border border-border rounded-lg flex items-center justify-center">
            <i class="fa-solid fa-bell text-warning"></i>
          </div>
          <div>
            <h3 class="text-text-primary font-medium">{{ 'seekerDashboard.alerts.alert2Location' | translate }}</h3>
            <p class="text-sm text-text-secondary">{{ 'seekerDashboard.alerts.alert2Details' | translate }}</p>
          </div>
        </div>
        <label class="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" class="sr-only peer" checked>
          <div
            class="w-11 h-6 bg-surface-elevated border border-border peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary peer-checked:border-primary shadow-inner">
          </div>
        </label>
      </div>
    </div>
  </div>
</div>